import { useParams } from 'react-router-dom'

// End
import { ReportCreatePageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { slugToTableId } from 'modules/ai_reports/lib/slug-tableid-mapping'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { AiReportsMainContent } from './components/ReportCreatePage'

const AiReportsPage = () => {
  const { slug } = useParams()
  const { company } = useCurrentSession()
  const sourceId = slugToTableId(slug ?? '')

  const { data, loading, error } = useQuery(ReportCreatePageDocument, {
    variables: { id: sourceId, companyId: company.id },
  })

  return (
    <>
      {!sourceId || loading || error || !data?.iris.factTable ? (
        <ResponsivePage.Body variant="fullscreen" loading={loading} error={error}>
          &nbsp;
        </ResponsivePage.Body>
      ) : (
        <AiReportsMainContent sourceId={sourceId} datasource={data.iris.factTable} />
      )}
    </>
  )
}

export default AiReportsPage
